import {create} from 'zustand';
import {SEND_ADDITIONAL_DOCS_DATA_DEFAULT} from './constants';
import {UseSendAdditionalDocsDataStoreProps} from './types';

export const useSendAdditionalDocsDataStore = create<UseSendAdditionalDocsDataStoreProps>(set => ({
	data: SEND_ADDITIONAL_DOCS_DATA_DEFAULT,
	setData: data => set({data}),
	resetData: () => set({data: SEND_ADDITIONAL_DOCS_DATA_DEFAULT}),
}));
